import { ICongThucTinhDiemSub } from "../../../model/response/category/ICongThucTinhDiemSub";
import { IThanhPhanMon } from "../../../model/response/category/IThanhPhanMon";
import { IThanhPhanThi } from "../../../model/response/category/IThanhPhanThi";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export interface ICongThucTinhDiemSubActionTypeBase<T> {
    id_cong_thuc: number;
    data: T;
}
export interface ICongThucTinhDiemSubChangeSelectedIds<T> {
    id_cong_thuc: number;
    listIds: number[];
    data: T;
}
export const eCongThucTinhDiemSubActionObj = {
    INI_START:0,
    LOAD_BY_CONG_THUC_START: 0,
    LOAD_BY_CONG_THUC_SUCCESS: {} as ICongThucTinhDiemSubActionTypeBase<ICongThucTinhDiemSub[]>,
    LOAD_BY_CONG_THUC_ERROR: {} as ICongThucTinhDiemSubActionTypeBase<string>,

    SAVE_START: {} as ICongThucTinhDiemSubActionTypeBase<ICongThucTinhDiemSub[]>,
    SAVE_SUCCESS: {} as ICongThucTinhDiemSubActionTypeBase<ICongThucTinhDiemSub[]>,
    SAVE_ERROR: {} as ICongThucTinhDiemSubActionTypeBase<string>,

    DELETE_START: 0,
    DELETE_SUCCESS: undefined,
    DELETE_ERROR: "",


    CHANGE_SELECTED_IDS: {} as ICongThucTinhDiemSubChangeSelectedIds<IThanhPhanMon[]>,
    CHANGE_SELECTED_THANH_PHAN_THI_IDS: {} as ICongThucTinhDiemSubChangeSelectedIds<IThanhPhanThi[]>,

    CHANGE_THANH_PHAN_MON: {} as ICongThucTinhDiemSub,
    CHANGE_THANH_PHAN_THI: {} as ICongThucTinhDiemSub,
};

export const eCongThucTinhDiemSubtIds =generateActionTypeIds(eCongThucTinhDiemSubActionObj, "CONG_THUC_TINH_DIEM_SUB");
export type ICongThucTinhDiemSubActionTypes = IGenericActionType<typeof eCongThucTinhDiemSubActionObj, "CONG_THUC_TINH_DIEM_SUB">;